import { useMemo } from "react";
import { useSelector } from "react-redux";

export const useHasDashBoardAccess = () => {
  const metaData = useSelector((state: any) => state.metaData);

  const canViewDashboard: boolean = useMemo(() => {
    return metaData.featureFlags && metaData.featureFlags.Dashboard;
  }, [metaData]);

  return { canViewDashboard };
};
